import { useGetBpayRestrictedBillersQuery } from './GetBpayRestrictedBillers.generated'

export const useDisabledBillerCodes = () => {
  const { data } = useGetBpayRestrictedBillersQuery()

  return {
    disabledBillers: data?.getBpayRestrictedBillers ?? [],
  }
}
